import { render, staticRenderFns } from "./TextList.vue?vue&type=template&id=46dcff09&scoped=true"
import script from "./TextList.vue?vue&type=script&lang=js"
export * from "./TextList.vue?vue&type=script&lang=js"
import style0 from "./TextList.vue?vue&type=style&index=0&id=46dcff09&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dcff09",
  null
  
)

export default component.exports